export const log = (channel: string, ...args: any[]): void => {
  console.log(`[${channel}] `, ...args);
};

export const error = (channel: string, ...args: any[]): void => {
  console.error(`[${channel}] `, ...args);
};

export const warn = (channel: string, ...args: any[]): void => {
  console.warn(`[${channel}] `, ...args);
};
